import { types, actions } from './requests'
export const DELETEUSER_TYPES = {
    ...types('DELETEUSER'),
}
export const DELETEUSER_ACTIONS = {
    ...actions('DELETEUSER'),
}
